import React from 'react';
import PendingSalesButton from '../Buttons/PendingSalesButton';
import PendingTransfersButton from '../../inventory/buttons/PendingTransfersButton';
import InventoryAdjustmentButton from '../../inventory/buttons/InventoryAdjustmentButton';
// import RequestProductButton from "../Buttons/RequestProductButton";
// import TransferStockButton from "../Buttons/TransferStockButton";
// import SalesReportButton from "../Buttons/SalesReportButton";

/**
 * 🧭 {@code SalesActionPanel}
 *
 * Panel de accesos rápidos del módulo de ventas.
 * Presenta botones funcionales con diseño elegante, sombreado sutil y espaciado equilibrado.
 *
 * 📌 Diseño refinado y responsivo.
 */
const SalesActionPanel: React.FC = () => {
  return (
    <section
      className="
        w-full rounded-xl 
        bg-white dark:bg-boxdark"
    >
      {/* 🔹 Encabezado */}
      <header className="mb-4">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
          <div>
            <h3 className="text-lg font-semibold tracking-tight text-slate-700 dark:text-white">
              Acciones Rápidas
            </h3>
            <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
              Accede rápidamente a tareas frecuentes del módulo de ventas.
            </p>
          </div>
        </div>

        {/* 🔹 Línea separadora */}
        <div className="mt-4 h-0.5 w-full rounded-full bg-primary/40 dark:bg-primary/30" />
      </header>

      {/* 🔘 Botones funcionales */}
      <div
        className="
          grid w-full grid-cols-1 gap-3
          sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4
        "
      >
        <PendingSalesButton />
        <PendingTransfersButton />
        <InventoryAdjustmentButton />
      </div>
    </section>
  );
};

export default SalesActionPanel;
